module.exports = __webpack_public_path__ + "static/monarch-house-logo-d2ac64a9a68fe3dcfb7761c06b37d46c.png";